import Store from "..";
import ReducerConstants from "../../config/ReduxConstant";
export const NEW_GRADE_CODE = "pk";

const INITIAL_STATE = {
    grades: []
};

export const gradeSeedData = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ReducerConstants.SET_GRADE_SEED_DATA: {
            return action.payload || INITIAL_STATE;
        }
        case ReducerConstants.UPDATE_GRADE_SEED_DATA: {
            const tempGrades = state?.grades;
            tempGrades?.forEach((grade) => {
                if(grade.code === NEW_GRADE_CODE){
                    grade.is_new = true;
                }
            });
            return {grades: tempGrades} || INITIAL_STATE;
        }
        default:
            return state
    }
}